module.exports = __webpack_public_path__ + "assets/img/33_839_big.4f8a9413.jpg";